// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"225":"15eb14e7","552":"4918f191","614":"fd6bb040","679":"5d936024","930":"e570d060"}[chunkId] + ".css";
};